import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { createUser, getUserDetails, updateUser } from "./UsersUtils";
import * as Yup from "yup";
import {
  CardContent,
  CardHeader,
  Select,
} from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import {
  addAccount,
  getAccountListByUser,
  returnAddAccountIsAvailable,
} from "../Account/AccountUtil";
import {
  Button, CardActions, FormControl, Grid,
  Input, InputLabel, MenuItem, Switch
} from "@mui/material";
import "./User.scss";
import userRoles from "../../configs/userRolesConfigs";
import { UserRolesEnum } from "../../Models/user";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import PhonePrefixForm from "../Helper/PhonePrefixForm/PhonePrefixForm";
import PhoneInputField from "../Helper/PhonePrefixForm/PhoneInputField";

const UserForm = () => {
  const dispatch = useDispatch();
  var { id } = useParams();
  const { mode } = useParams();
  const isAddMode = mode === "0" ? true : false;
  const [user, setUser] = useState({ status: true });
  const [errorMessage, seterrorMessage] = useState("");
  const navigate = useNavigate();
  const [isFinished, setIsFinished] = useState(false);
  const [isShowNewAccountInput, setIsShowNewAccountInput] = useState(false);
  const [isAddAccountIsAvailable, setIsAddAccountIsAvailable] = useState(false);
  const [countryCode, setCountryCode] = useState('');
  const [accountName, setAccountName] = useState("");
  const digitsAndEnglishOnly = /^[A-Za-z-0-9]+$/;
  const accounts = useSelector(
    (state: any) => state.account.accounts_per_user_list
  );
  const userRole = useSelector((state: any) => state.general.userRol);

  const validationSchema = Yup.object().shape({
    // username: Yup.string()
    //   .matches(
    //     digitsAndEnglishOnly,
    //     "Must contein Only English letters or Digits"
    //   )
    //   .min(3, "Must contein at least 3 characters!")
    //   .required("Required"),
    first_name: Yup.string()
      .matches(
        digitsAndEnglishOnly,
        "Must contein Only English letters or Digits"
      )
      .min(2, "Must contein at least 2 characters!")
      .required("Required"),
    last_name: Yup.string()
      .matches(
        digitsAndEnglishOnly,
        "Must contein Only English letters or Digits"
      )
      .min(2, "Must contein at least 2 characters!")
      .required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    password: Yup.string()
      .matches(
        digitsAndEnglishOnly,
        "Must contein Only English letters or Digits"
      )
      .min(8, "Must contein at least 8 characters!")
      .max(32, "Must contein until 32 characters!"),

    phone: Yup.string()
      // .matches(
      //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      //   "Phone number is not valid"
      // )
      // .min(9, "Phone number is not valid")
      // .max(10, "Phone number is not valid")
      .required("Required!"),
    role: Yup.string().required("Required!"),
    commission_percentage: Yup.number().transform(
      value => (isNaN(value) ? undefined : value)).typeError('Please enter a valid number')
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await getUserDetails(dispatch, id ? id : null);
      setUser(response);
      setIsFinished(true);
      getAccountListByUser(dispatch, response["id"]);
      setIsAddAccountIsAvailable(
        await returnAddAccountIsAvailable(dispatch, response["id"])
      );
    };
    if (!isAddMode) {
      setIsFinished(false);
      fetchData();
    } else {
      setIsFinished(true);
    }
  }, [id]);

  // useEffect(() => {
  //   console.log('user phone: ', user['phone']);
  // }, [user['phone']]);

  const onSubmit = async (data) => {
    data['country_code'] = `+${countryCode}`;
    var response = isAddMode
      ? await createUser(dispatch, data)
      : await updateUser(dispatch, user['id'], data);
    if (response["message"] === "success" && userRole === userRoles.admin)
      navigate("/layout/administrator/users/");
    else {
      seterrorMessage(response["message"]);
    }
  };

  const openAccountInput = () => {
    setIsShowNewAccountInput(!isShowNewAccountInput);
  };

  const addNewAccount = async () => {
    await addAccount(dispatch, accountName, user["id"]);
    setIsShowNewAccountInput(false);
    setIsAddAccountIsAvailable(false);
  };

  const onchangeInput = (event) => {
    setAccountName(event.target.value);
  };

  return (
    <Grid container justifyContent="center">
      <Grid item md={6} mt={4}>
        <CardHeader className="text-center"
          title={isAddMode ? "Add User" : "Edit User"}></CardHeader>
        {(isAddMode || (!isAddMode && user["email"] && isFinished)) && (
          <Formik
            initialValues={user}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              isValid,
              values,
              setFieldValue,
              handleChange,
              handleBlur,
              errors,
            }) => {
              return (
                <Form className="page-form">
                  <CardContent>
                    <Grid item container spacing={2} >
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>First Name*</InputLabel>
                        <Field
                          label=""
                          variant="outlined"
                          placeholder=""
                          fullWidth
                          required
                          name="first_name"
                          value={values.first_name}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Last Name*</InputLabel>
                        <Field
                          label=""
                          variant="outlined"
                          placeholder=""
                          fullWidth
                          required
                          name="last_name"
                          value={values.last_name}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Password</InputLabel>
                        <Field
                          name="password"
                          value={values.password || ""}
                          type="password"
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Email*</InputLabel>
                        <Field
                          name="email"
                          value={values.email || ""}
                          component={TextField}
                        />
                      </Grid>
                      {(isAddMode || isFinished) && <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Phone Number*</InputLabel>
                        <Field
                          component={PhoneInputField}
                          name="phone"
                          value={values.phone}
                          setCountryCode={(val) => {
                            setCountryCode(val);
                          }}
                        />
                      </Grid>}
                      {isFinished && isAddMode && (
                        <Grid item xs={12} sm={6} md={12} mb={1}>
                          <InputLabel id="demo-simple-select-label">
                            Role*
                          </InputLabel>
                          <FormControl fullWidth>
                            <Select
                              name="role"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={values.role}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              variant="outlined"
                            >
                              {Object.keys(UserRolesEnum).map((key) =>
                                <MenuItem value={key}>{UserRolesEnum[key]}</MenuItem>)
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                      {isFinished && !isAddMode && userRole === userRoles.admin && (
                        <Grid item xs={12} sm={6} md={12} mb={1}>
                          <InputLabel id="edit-role-label">Role*</InputLabel>
                          <FormControl fullWidth>
                            <Select
                              name="role"
                              labelId="edit-role-label"
                              id="edit-role-select"
                              value={values.role}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              variant="outlined"
                            >
                              {Object.keys(UserRolesEnum).map((key) => (
                                <MenuItem value={key} key={key}>
                                  {UserRolesEnum[key]}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )}

                      {(userRole === 'admin' && (user['role'] === userRoles.salesperson ||
                        values.role === userRoles.salesperson)) || (userRole !== userRoles.account &&
                          (user['role'] === userRoles.account ||
                            values.role === userRoles.account)) && (
                          <Grid item xs={12} sm={6} md={12} mb={1}>
                            <InputLabel>Commission Percentage</InputLabel>
                            <Field
                              name="commission_percentage"
                              value={values.commission_percentage || ""}
                              type="text"
                              component={TextField}
                            />
                          </Grid>
                        )}
                      {userRole === 'admin' && (user['role'] === userRoles.salesperson ||
                        values.role === userRoles.salesperson) && (
                          <Grid item xs={12} sm={6} md={12} mb={1}>
                            <InputLabel>Promo Code</InputLabel>
                            <Field
                              name="promotion_code"
                              value={values.promotion_code || ""}
                              type="text"
                              component={TextField}
                            />
                          </Grid>
                        )}
                      {userRole === 'admin' && user['role'] === userRoles.account &&
                        <Grid item xs={12} sm={6} md={12}>
                          <InputLabel>How did you hear about us?</InputLabel>
                          <Field
                            label=""
                            variant="outlined"
                            placeholder=""
                            fullWidth
                            disabled
                            name="free_text"
                            value={values.free_text}
                            type="text"
                            className="w-100"
                            component="textarea"
                          />
                        </Grid>}

                      {id && (
                        <Grid item xs={12} sm={6} md={12} mb={1}>
                          <Switch
                            name="status"
                            value="Y"
                            color="primary"
                            checked={values.status !== "N"}
                            onChange={(event, checked) => {
                              setFieldValue("status", checked ? "Y" : "N");
                            }}
                          />
                          <label>Status</label>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                  <CardActions>
                    <Button
                      sx={{ mt: 1 }}
                      disabled={!isValid}
                      className="blue-btn w-100 h-50p"
                      type="submit"
                    >
                      {isAddMode ? "Create" : "Update Info"}
                    </Button>
                  </CardActions>
                </Form>
              );
            }}
          </Formik>
        )}
        <Grid item xs={12} sm={6} md={12}>
          {isFinished && user["role"] === userRoles.account && (
            <div className="accounts-wraper">
              <div className="account-title">Accounts:</div>
              {accounts.map((item) => (
                <div key={item.id}>{item.account_name}</div>
              ))}
              {isAddAccountIsAvailable && (
                <AddOutlinedIcon
                  className="pointer"
                  onClick={openAccountInput}
                ></AddOutlinedIcon>
              )}
              {isShowNewAccountInput && (
                <div>
                  <Input
                    required
                    name="Account Name"
                    onChange={onchangeInput}
                    placeholder="Account Name"
                  />
                  <Button
                    type="submit"
                    sx={{ marginLeft: 2 }}
                    className="blue-btn"
                    onClick={addNewAccount}
                  >
                    Add
                  </Button>
                </div>
              )}
            </div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default UserForm;
